import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  EffectRef,
  inject,
  input,
  InputSignal,
  signal,
  WritableSignal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AppNavigation } from '../../../../types/navigation.types';
import { BaseComponent } from '../../../base/base.component';
import { IconButtonDirective } from '../../../button/icon/icon-button.directive';
import { LanguagePickerComponent } from '../../../language-picker/language-picker.component';
import { NavigationComponent } from '../../../navigation/navigation.component';
import { ThemePickerComponent } from '../../../theme-picker/theme-picker.component';

@Component({
  selector: 'immo-header-navigation-mobile',
  imports: [
    MatButtonModule,
    MatIconModule,
    CommonModule,
    NavigationComponent,
    ThemePickerComponent,
    LanguagePickerComponent,
    IconButtonDirective,
  ],
  templateUrl: './header-navigation-mobile.component.html',
  styleUrl: './header-navigation-mobile.component.css',
})
export class HeaderNavigationMobileComponent extends BaseComponent {
  // -----------------------------------------------------------------------------------------------------
  // @ DEPENDENCIES
  // -----------------------------------------------------------------------------------------------------

  private readonly router: Router = inject(Router);

  // -----------------------------------------------------------------------------------------------------
  // @ INPUTS
  // -----------------------------------------------------------------------------------------------------

  readonly navigation: InputSignal<AppNavigation> = input.required<AppNavigation>();

  // -----------------------------------------------------------------------------------------------------
  // @ INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  readonly isOpen: WritableSignal<boolean> = signal<boolean>(false);

  // -----------------------------------------------------------------------------------------------------
  // @ EFFECTS
  // -----------------------------------------------------------------------------------------------------

  closeOnNavigationEffect: EffectRef = effect(() => {
    if (this.router.currentNavigation()) {
      this.isOpen.set(false);
    }
  });
}
